import React from "react";
import ResendActivationForm from "../../components/Auth/ResendActivationForm";

const ResendActivation = () => {
    return (
        <>
            <ResendActivationForm />
        </>
    );
};

export default ResendActivation;